import { t } from '@/features/i18n/utils';
import { BidBreadcrumbs } from '@/features/bids/components/bid-breadcrumbs';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { H1 } from '@/ui/components/heading';
import {
  MainContainer,
  MainHeader,
  MainHeaderBackButton,
  MainScrollArea,
} from '@/ui/components/main';
import { Sidenav, SidenavItem, SidenavLink, SidenavList } from '@/ui/components/sidenav';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId, workspaceId, bidId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <BidBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Settings', nb: 'Innstillinger' })}</BreadcrumbPage>
        </BidBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <MainScrollArea>
        <MainHeader className="max-md:hidden">
          <H1>
            <MainHeaderBackButton />
            {t({ en: 'Settings', nb: 'Innstillinger' })}
          </H1>
        </MainHeader>
        <div className="flex flex-col @3xl:flex-row">
          <Sidenav className="@3xl:sticky top-0 h-fit">
            <SidenavList className="p-4">
              <SidenavItem>
                <SidenavLink
                  to="/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings"
                  params={{ projectId, workspaceId, bidId }}
                >
                  {t({ en: 'General', nb: 'Generelt' })}
                </SidenavLink>
              </SidenavItem>
            </SidenavList>
          </Sidenav>
          <MainContainer>
            <Outlet />
          </MainContainer>
        </div>
      </MainScrollArea>
    </>
  );
}
